import { request } from '../request';

const systemApi = {
  /**
   * 获取当前移动设备已绑定的门店
   */
  getBoundStore(androidId: string) {
    return request<StoreInfo>({ path: '/pad/system/v1/getBoundStore', query: { androidId } });
  },
  /**
   * 输入密码绑定门店
   */
  bindStore(params: BindStoreParams) {
    return request<StoreInfo>({
      path: '/pad/system/v1/bindStore',
      method: 'POST',
      query: { password: params?.password },
      data: params.deviceInfo,
    });
  },
  /**
   * 获取专属 logo、背景图片
   */
  getExclusiveImages() {
    return request<GetExclusiveImagesResponse>({ path: '/pad/system/v1/getExclusiveImages' });
  },
  /**
   * 获取APK最新信息
   */
  getLatestAPK() {
    return request<GetLatestAPKResponse>({ path: '/pad/system/v1/getAPKInfo' });
  },
  /**
   * 记录用户坐标信息
   */
  recordLocation(params: RecordLocationParams) {
    return request<string>({ path: '/pad/system/v1/recordLocation', data: params, method: 'POST' });
  },
  /**
   * 记录崩溃日志信息
   */
  logCrash(params: LogCrashParams) {
    return request<string>({
      path: '/pad/system/v1/log/crash',
      data: params,
      method: 'POST',
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 记录网络日志信息
   */
  logNetwork(params: LogNetworkParams) {
    return request<string>({
      path: '/pad/system/v1/log/network',
      data: params,
      method: 'POST',
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 更新门店名称
   */
  updateStoreName(params: { customName: string }) {
    return request<any>({
      path: '/pad/system/v1/store/update',
      data: params,
      method: 'POST',
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 根据门店理疗类型筛选引导视频
   */
  getGuideVideoFilterInfo() {
    return request<GetGuideVideoFilterInfoResponse>({
      path: '/pad/system/v1/guide/video/filters',
    });
  },
  /**
   * 获取R2预热信息
   */
  getR2PreheatInfo() {
    return request<R2PreheatInfoResponse>({ path: '/pad/settings/v1/home/banner' });
  },
};

export default systemApi;
